module.exports = __webpack_public_path__ + "img/board_status.d53655e6.png";